var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 28,
    viewBox: "0 0 20 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8906 0C18.3125 0 19.5156 1.20312 19.5156 2.625V25.375C19.5156 26.8516 18.3125 28 16.8906 28H2.89062C1.41406 28 0.265625 26.8516 0.265625 25.375V2.625C0.265625 1.20312 1.41406 0 2.89062 0H16.8906ZM12.5156 24.5C12.5156 24.0625 12.0781 23.625 11.6406 23.625H8.14062C7.64844 23.625 7.26562 24.0625 7.26562 24.5C7.26562 24.9922 7.64844 25.375 8.08594 25.375H11.6406C12.0781 25.375 12.5156 24.9922 12.5156 24.5ZM16.0156 21V3.5H3.76562V21H16.0156Z",
    fill: "#15A9AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.28316cfa028b8c33ad1801b57545766e.svg";
export { ForwardRef as ReactComponent };